import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { NavLink, useNavigate } from "react-router-dom";
import { Button, Input } from "../../components";
import { SendOTP } from "../../utilities/api/auth/auth-service";
import { messages } from "../../utilities/Messages";

const ForgotPassword = () => {
  const [phoneNo, setPhoneNo] = useState(0);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const getMessage = messages.auth;
  useEffect(() => {
    document.body.classList.add("forgot-page");
    return () => {
      document.body.classList.remove("forgot-page");
    };
  }, []);

  const ForgotPass = async () => {
    const result = await SendOTP({ phone: phoneNo, otpFor: "forgetPassword" });
    if (result.status === 200) {
      navigate("/reset-password", {
        state: {
          message: result.data.message,
          otpNumber: result.data.data.otpNumber,
          phone: phoneNo,
        },
      });
    }
    if (result.response.status === 400) {
      toast.error(result.response.data.message);

    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (phoneNo < 1000000000 || phoneNo > 10000000000) {
      setMessage(getMessage.otpFor_isEnum);
    } else {
      ForgotPass();
    }
  };
  return (
    <>
      <div className="container">
        <div className="row justify-content-center align-items-center bg-height">
          <div className="col-md-5">
            <div className="card">
              <div className="card-body">
                <form>
                  <h3 className="card-title mb-4 text-start">
                    Forgot Password
                  </h3>

                  <div className="mb-3 text-start">
                    <label htmlFor="number" className="form-label">
                      Phone Number <small className="text-danger">*</small>
                    </label>
                    <Input
                      onChange={(e: any) => setPhoneNo(e.target.value)}
                      type="number"
                      placeholder="Enter Phone Number"
                      id="number"
                      name="number"
                      className="form-control"
                      maxLength={10}
                      onKeyDown={(e: any) =>
                        ["e", ".", "-", "+"].includes(e.key) &&
                        e.preventDefault()
                      }
                      onWheel={(e: any) => e.target.blur()}
                    />
                    <span className="error-msg"> {message}</span>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6 text-start">
                      <NavLink to="/">Back to Login</NavLink>
                    </div>
                    <div className="col-md-6 text-end">
                      <Button
                        onClick={handleSubmit}
                        bname="Submit"
                        name="forgot-password"
                        id="forgot-password"
                        className="btn btn-primary rounded-1"
                      />
                    </div>
                  </div>
                </form>
              </div>
            </div>


          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
};
export { ForgotPassword };
